const contactPageData = [
    {
        'contacts': {
            'adress': 'Krasta iela 91/93, Rīga, LV-1019',
            'googleMapsLink': 'https://www.google.com/maps/place/SIA+%22Tropiks+AZ%22,+Krasta+iela+93%2F91,+Latgales+priekšpilsēta,+Rīga,+LV-1019/@56.9300169,24.1504899,17z/data=!4m6!3m5!1s0x46eed1e12f47184b:0x8d137453882057db!8m2!3d56.9300169!4d24.1504899!16s%2Fg%2F1ptvr2ndn',
            'countryCode': '+371',
            'phoneNumber': '29618633',
            'eMail': 'tropiks.az@inbox.lv'
        },
        'workingHours': [
            {
                'day': 'Pirmdiena',
                'time': '11:00 - 18:30'
            },
            {
                'day': 'Otrdiena',
                'time': '11:00 - 18:30'
            },
            {
                'day': 'Trešdiena',
                'time': '11:00 - 18:30'
            },
            {
                'day': 'Ceturtdiena',
                'time': '11:00 - 18:30'
            },
            {
                'day': 'Piektdiena',
                'time': '11:00 - 18:30'
            },
            {
                'day': 'Sestdiena',
                'time': 'Slēgts'
            },
            {
                'day': 'Svētdiena',
                'time': 'Slēgts'
            }
        ],
        'holidayworkingHours': [
            {
                'day': '23.12.',
                'time': '11:00 - 19:00'
            },
            {
                'day': '24.12.',
                'time': '11:00 - 18:00'
            },
            {
                'day': '25.12.',
                'time': '12:00 - 19:00'
            },
            {
                'day': '26.12.',
                'time': '11:00 - 19:00'
            },
            {
                'day': '27.12.',
                'time': '10:00 - 20:00'
            },
            {
                'day': '28.12.',
                'time': '10:00 - 20:00'
            },
            {
                'day': '29.12.',
                'time': '10:00 - 20:00'
            },
            {
                'day': '30.12.',
                'time': '10:00 - 20:00'
            },
            {
                'day': '31.12.',
                'time': '10:00 - 22:00'
            }
        ],
        'googleMap': 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d544.2747736445085!2d24.1502457!3d56.9299686!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46eed1e12f47184b%3A0x8d137453882057db!2sSIA%20%22Tropiks%20AZ%22!5e0!3m2!1slv!2slv!4v1687373520186!5m2!1slv!2slv',
        'intro': 'SIA "Tropiks AZ" pirotehnikas tirgū darbojas kopš 2000.gada.',
        'mission': 'Mēs esam lepni piedāvāt augstas kvalitātes pirotehniku un nodrošināt mūsu klientiem profesionālu atbalstu, lai jūs varētu piedzīvot drošu un aizraujošu salūtu.',
        'principleIntro': 'Lai apmierinātu klientu vajadzības, mēs koncentrējamies uz trim principiem:',
        'principles': [
            {
                'principle': "KVALITATĪVA PRECE",
                'value': "mūsu sortimentā ir plašs pirotehnisko izstrādājumu klāsts, kas apmierinās ikviena klienta vēlmes. Lai gan mums ir iespēja iegūt gandrīz neierobežotu pirotehnisko izstrādājumu klāstu no mūsu piegādātājiem, mēs rūpīgi izvēlamies tikai tos izstrādājumus, kas nodrošina labu balansu starp veiktspēju un patērētāja izmaksām. Protams, drošība ir galvenais faktors šajā formulējumā."
            },
            {
                'principle': "ADEKVĀTA CENA",
                'value': "atšķirībā no citiem izplatītājiem, mēs cenšamies vienoties par vislabāko cenu ar mūsu piegādātājiem un šo priekšrocību nododam tālāk mūsu klientiem, nodrošinot zemākās cenas Rīga un tās apkārtnē."
            },
            {
                'principle': "PROFESIONĀLA APAKPOŠANA",
                'value': "mūsu profesionālā komanda rūpēsies par to, lai palīdzētu jums atrast piemērotāko salūtu pēc jūsu vajadzībām - ņemot vērā laika apstākļus, pasākuma vietu, skatītāju skaitu un citus faktorus, - nodrošinot salūta drošas lietošanas instrukcijas, kā arī palīdzot iegādāties preces veikalā."
            }
        ],
        'propsIntro': 'Uzņēmuma rekvizīti',
        'props': [
            {
                'name': 'Nosaukums',
                'value': 'Sabiedrība ar ierobežotu atbildību "TROPIKS AZ"'
            },
            {
                'name': 'Juridiskā adrese',
                'value': '"Jaunrubeņi", Ciemupe, Ogresgala pagasts, Ogres novads, LV-5041'
            },
            {
                'name': 'Reģistrācijas nr.',
                'value': '40003506230'
            },
            {
                'name': 'PVN maksātāja nr.',
                'value': 'LV40003506230',
            },
            {
                'name': 'Bankas nosaukums',
                'value': 'SIA "Citadele Leasing"',
            },
            {  
                'name': 'Bankas konts',
                'value': 'LV85PARX0016220570002',
            },
            {   
                'name': 'SWIFT kods',
                'value': 'PARXLV22'
            }
        ]
    }
]

export default contactPageData;